const timeZeroFix = (value: string, delimiter: string = ':') => {
  value = String(value);
  const parts = value.split(delimiter);
  for (let i = 0; i < parts.length; i++) {
    if (parts[i].length === 1) {
      parts[i] = `0${parts[i]}`;
    }
  }
  return parts.join(delimiter);
};

export default timeZeroFix;
